import React from "react";
import BtnClose from "../../assets/images/btn-close.svg";

import partnerOne from "../../assets/images/partner-1.png";
import partnerTwo from "../../assets/images/partner-2.png";
import partnerThree from "../../assets/images/partner-3.png";
import partnerFour from "../../assets/images/partner-4.png";
import partnerFive from "../../assets/images/partner-5.png";
import "./partnerPopup.scss";

export const PartnerPopup = (props) => {
  // const [userDropdown, setuserDropdown] = useState(false);

  return (
    <div
      className={props.partnerToggle ? "partner-popup active" : "partner-popup"}
    >
      <div className="partner-sec">
        <button type="button" className="close" onClick={props.partnerHandler}>
          <img src={BtnClose} alt="" />
        </button>

        <div className="colm">
          <h6>Partners</h6>
          <ul>
            <li>
              <img src={partnerOne} alt="" />
            </li>
            <li>
              <img src={partnerTwo} alt="" />
            </li>
            <li>
              <img src={partnerThree} alt="" />
            </li>
            <li>
              <img src={partnerFour} alt="" />
            </li>
            <li>
              <img src={partnerFive} alt="" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
